import { GAME_WIDTH, GAME_HEIGHT } from '../config.js';
import { lockInput, unlockInput } from './inputLock.js';
import { audioManager } from '../audio/AudioManager.js';
import { RULES } from './gameRules.js';
import { iconText } from './iconText.js';
import { enlargeForTouch } from './touchEnlarge.js';

// Language is remembered across games/sessions; Polish is the family default.
const LS_LANG = 'sd_rules_lang';

// In-game instructions modal (BoardGameScene "📖 Instrukcja" button): one panel
// per game from gameRules.js, PL/EN toggle in the top-right corner. Same modal
// idioms as RankingModal: input lock, depth 2000, pointerup-only, overlay close.
export function showRulesModal(scene, gameId) {
  const rules = RULES[gameId];
  if (!rules) return;

  const W = 720, H = 620;
  const cx = GAME_WIDTH / 2, cy = GAME_HEIGHT / 2;
  const layer = scene.add.container(0, 0).setDepth(2000);
  lockInput(scene);

  const overlay = scene.add.rectangle(0, 0, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0.6)
    .setOrigin(0, 0).setInteractive();
  const box = scene.add.rectangle(cx, cy, W, H, 0xfdf6e3).setStrokeStyle(4, 0x5b4636);
  layer.add([overlay, box]);
  enlargeForTouch(scene, layer, { x: cx, y: cy, w: W, h: H }, { overlay });

  let lang = localStorage.getItem(LS_LANG) === 'en' ? 'en' : 'pl';

  const title = iconText(scene, cx - W / 2 + 28, cy - H / 2 + 24, '', {
    fontFamily: 'system-ui', fontSize: '26px', color: '#2e2116', fontStyle: 'bold',
  }).setOrigin(0, 0);
  const body = iconText(scene, cx - W / 2 + 28, cy - H / 2 + 72, '', {
    fontFamily: 'system-ui', fontSize: '17px', color: '#3b2d20', lineSpacing: 7,
    wordWrap: { width: W - 56 },
  }).setOrigin(0, 0);
  layer.add([title, body]);

  // Top-right corner: PL | EN toggle, then the close ✕ at the very edge.
  const closeBtn = iconText(scene, cx + W / 2 - 10, cy - H / 2 + 10, '×', {
    fontFamily: 'system-ui', fontSize: '24px', color: '#a33', fontStyle: 'bold',
  }).setOrigin(1, 0).setInteractive({ useHandCursor: true });
  const langBtns = ['pl', 'en'].map((code, i) => iconText(scene, 
    cx + W / 2 - 110 + i * 42, cy - H / 2 + 14, code.toUpperCase(), {
      fontFamily: 'system-ui', fontSize: '19px',
    }).setOrigin(0, 0).setInteractive({ useHandCursor: true }));
  layer.add([closeBtn, ...langBtns]);

  const render = () => {
    const t = rules[lang];
    title.setText(t.title);
    body.setText(t.body);
    langBtns.forEach((btn, i) => {
      const active = (i === 0 ? 'pl' : 'en') === lang;
      btn.setColor(active ? '#2e2116' : '#a08a6a');
      btn.setFontStyle(active ? 'bold' : 'normal');
    });
  };
  render();

  langBtns.forEach((btn, i) => btn.on('pointerup', () => {
    const code = i === 0 ? 'pl' : 'en';
    if (code === lang) return;
    lang = code;
    localStorage.setItem(LS_LANG, lang);
    audioManager.playSfx('click');
    render();
  }));

  const close = () => { audioManager.playSfx('click'); unlockInput(scene); layer.destroy(); };
  closeBtn.on('pointerup', close);
  overlay.on('pointerup', close);
}
